import script from "./VideoHeroBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoHeroBanner.vue?vue&type=script&setup=true&lang=js"

import "./VideoHeroBanner.vue?vue&type=style&index=0&id=176d4230&lang=scss"

const __exports__ = script;

export default __exports__